export default "<div  class=\"kt-portlet\" [ngClass]=\"class\" #portlet>\n  <ng-content></ng-content>\n</div>\n";